import { useCart } from '@chordcommerce/react-autonomy';
import { Text } from 'theme-ui';
import SpinnerBar from '~/components/Spinner/loader';
import { Fragment } from 'react';
import AnimatedButton from '~/components/Generic/AnimatedButton';
import { AnimatePresence, motion } from 'framer-motion';
import { useTranslate } from '~/hooks/utils/use-translate';

const CheckoutButton = ({ apiError, isLoading, stockError }) => {
  const translate = useTranslate();
  const {
    cart: { lineItems },
  } = useCart();

  const disabled = !lineItems || lineItems.length === 0 || isLoading;

  return (
    <Fragment>
      <AnimatedButton
        variant="knockout"
        sx={{
          mx: 'auto',
          opacity: disabled ? 0.8 : 1,
          cursor: disabled ? 'not-allowed !important' : 'pointer',
          height: ['4rem', '4.8rem !important'],
          width: '100% !important',
          pr: '11px',
          fontSize: ['1.2rem', '1.2rem !important'],
        }}
        disabled={disabled}
        loading={isLoading}
      >
        {isLoading ? <SpinnerBar data-testid="spinner" color="inherit" /> : translate('cart.checkout')}
      </AnimatedButton>

      {apiError && (
        <Text color="errorDark" variant="formError" mt="1.5rem">
          {apiError}
        </Text>
      )}

      <AnimatePresence>
        {stockError && stockError.length > 0 && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.2 }}
            sx={{ mt: '1.5rem', fontSize: '1.2rem', lineHeight: '1.2', color: 'error' }}
          >
            {stockError.map((item) => (
              <Text as="p" key={item}>
                <span sx={{ textTransform: 'capitalize' }}>{item} </span>is no longer available.
              </Text>
            ))}

            <Text as="p">Please remove from cart to proceed.</Text>
          </motion.div>
        )}
      </AnimatePresence>
    </Fragment>
  );
};

export default CheckoutButton;
